var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDurationIcon = function SvgDurationIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M12 3.4c-4.7 0-8.6 3.8-8.6 8.6 0 4.7 3.8 8.6 8.6 8.6s8.6-3.8 8.6-8.6c0-4.7-3.9-8.6-8.6-8.6zM17 15c-.2.3-.5.5-.8.5-.2 0-.3 0-.5-.1L11.5 13c-.3-.2-.5-.6-.5-1V5.7c0-.5.4-1 1-1s1 .4 1 1v5.8l3.7 2.1c.4.3.6.9.3 1.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 1.5C6.2 1.5 1.5 6.2 1.5 12S6.2 22.5 12 22.5 22.5 17.8 22.5 12 17.8 1.5 12 1.5zm0 19.1c-4.7 0-8.6-3.8-8.6-8.6 0-4.7 3.8-8.6 8.6-8.6s8.6 3.8 8.6 8.6c0 4.7-3.9 8.6-8.6 8.6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16.7 13.7 13 11.5V5.7c0-.5-.4-1-1-1s-1 .4-1 1V12c0 .4.1.7.5.9l4.2 2.4c.2.1.3.1.5.1.3 0 .7-.2.8-.5.3-.4.1-1-.3-1.2z"
  })));
};
export default SvgDurationIcon;